import { render, staticRenderFns } from "./CashWallet.vue?vue&type=template&id=38230e3c&scoped=true"
import script from "./CashWallet.vue?vue&type=script&lang=js"
export * from "./CashWallet.vue?vue&type=script&lang=js"
import style0 from "./CashWallet.vue?vue&type=style&index=0&id=38230e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38230e3c",
  null
  
)

export default component.exports